import axios from './axiosInstance';

export const addQuestion = async ({
  data
}) => {
  try {
    const response = await axios({
      url: '/add-question',
      method: 'POST',
      data: data
    })

    return ({
      data: response.data,
      error: null
    })

  } catch (error) {
    return {
      data: null,
      error: error
    }
  }
}

export const getQuestions = async () => {
  try {
    const response = await axios({
      url: '/get-questions',
      method: 'GET'
    })

    return ({
      data: response.data,
      error: null
    })

  } catch (error) {
    return {
      data: null,
      error: error
    }
  }
}

export const getQuestion = async ({
  id
}) => {
  try {
    const response = await axios({
      url: `/get-question/${id}`,
      method: 'GET'
    })

    return ({
      data: response.data,
      error: null
    })

  } catch (error) {
    return {
      data: null,
      error: error
    }
  }
}

export const updateQuestion = async ({
  id,
  data
}) => {
  try {
    const response = await axios({
      url: `/update-question/${id}`,
      method: 'PUT',
      data : data
    })

    return ({
      data: response.data,
      error: null
    })

  } catch (error) {
    return {
      data: null,
      error: error
    }
  }
}

export const deleteQuestion = async ({
  id
}) => {
  try {
    const response = await axios({
      url: `/delete-question/${id}`,
      method: 'DELETE'
    })

    return ({
      data: response.data,
      error: null
    })

  } catch (error) {
    return {
      data: null,
      error: error
    }
  }
}